import { ChangeDetectionStrategy, Component } from "@angular/core";
import { RouterLink } from "@angular/router";
import { IButtonDirective } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { OverlayLayoutComponent } from "@m19-board/overlay/overlay-layout/overlay-layout.component";
import { OverlayRule } from "@m19-board/overlay/overlay-service/overlay-rules";

@Component({
  selector: "app-sd-not-supported-for-kdp-overlay",
  imports: [TranslocoDirective, OverlayLayoutComponent, IButtonDirective, RouterLink],
  template: `
    <app-overlay-layout *transloco="let t" variant="info" [title]="t('overlays.sd_not_supported_for_kdp_title')">
      <p overlayBody>{{ t("overlays.only_sp_available_for_kdp") }}</p>
      <a overlayCta iButton variant="secondary" routerLink="/advertising/sponsored-product">
        {{ t("overlays.go_to_sponsored_products") }}
      </a>
    </app-overlay-layout>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SdNotSupportedForKdpOverlayComponent {
  static readonly rule = OverlayRule.SD_NOT_SUPPORTED_FOR_KDP;
}
